import styles from './FJLabeledSwitch.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import FJSwitchButton from '../FJSwitchButton/FJSwitchButton';
import FJDropdownNew from '../FJDropDown/FJDropdownNew';
import classNames from 'classnames';
import FJHelpIcon from '../../../assets/svg/help.svg?react';

const FJLabeledSwitch = ({ title, onChange, active, disable, desc, className, hideDesc = false }) => {
    const renderTrigger = config => {
        return (
            <div className={styles.labeled_switch_icon} onClick={config.onClick} ref={config.ref}>
                <FJHelpIcon />
            </div>
        );
    };

    const renderOverlay = config => {
        return (
            <div className={styles.labeled_switch_desc} ref={config.ref}>
                {FJLocalStore._(desc)}
            </div>
        );
    };

    return (
        <div className={classNames(styles.labeled_switch, className, { [styles.disabled]: disable })}>
            <div className={styles.labeled_switch_title}>
                {FJLocalStore._(title)}
                {!hideDesc && (
                    <FJDropdownNew
                        renderTrigger={renderTrigger}
                        useAnchorBody
                        placement='rightTop'
                        trigger='click'
                        renderOverlay={renderOverlay}
                        offsetLeft={8}
                        offsetTop={-11}
                        isTopLayer
                    />
                )}
            </div>

            <FJSwitchButton active={active} onChange={onChange} className={styles.labeled_switch_switch} />
        </div>
    );
};

export default FJLabeledSwitch;
